export const darkTheme = {
    mode: "dark",
    bg:"#080D16",
    bgLight: "#0E1624",
    bgTail: "#050812",
    primary:"#F8FAFC",
    secondary:"#FB923C",
    accent:"#38BDF8",
    text_primary:"#F8FAFC",
    text_secondary:"#CBD5E1",
    text_muted:"#94A3B8",
    card:"#121C2B",
    card_light: '#162235',
    card_soft: '#0F1726',
    border:"#263449",
    border_strong:"#3B4A62",
    glass:"rgba(14, 22, 36, 0.82)",
    button:"#F8FAFC",
    hover:"rgba(249, 115, 22, 0.14)",
    active:"rgba(56, 189, 248, 0.13)",
    success:"#22C55E",
    warning:"#F59E0B",
    error:"#FB7185",
    shadow:"rgba(0, 0, 0, 0.34)",
    navBg:"rgba(14, 22, 36, 0.84)",
    navBorder:"rgba(71, 85, 105, 0.62)",
    navShadow:"rgba(0, 0, 0, 0.32)",
    navText:"#F8FAFC",
    navMuted:"#94A3B8",
    navControl:"rgba(15, 23, 42, 0.86)",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    mode: "light",
    bg:"#F8F9FB",
    bgLight: "#FFFFFF",
    bgTail: "#EEF1F5",
    primary:"#0E1726",
    secondary:"#B94D08",
    accent:"#0EA5A4",
    text_primary:"#111827",
    text_secondary:"#4B5563",
    text_muted:"#7C8491",
    card:"#FFFFFF",
    card_light: '#F8F9FB',
    card_soft: '#EEF1F5',
    border:"#DCE2E9",
    border_strong:"#CBBBA8",
    glass:"rgba(255, 255, 255, 0.86)",
    button:"#0E1726",
    hover:"rgba(249, 115, 22, 0.10)",
    active:"rgba(14, 165, 164, 0.12)",
    success:"#15803D",
    warning:"#B45309",
    error:"#BE123C",
    shadow:"rgba(72, 50, 28, 0.16)",
    navBg:"rgba(255, 255, 255, 0.88)",
    navBorder:"rgba(229, 218, 204, 0.92)",
    navShadow:"rgba(74, 53, 32, 0.14)",
    navText:"#132034",
    navMuted:"#4B5563",
    navControl:"rgba(255, 255, 255, 0.94)",
    white:"#FFFFFF",
    black:"#000000",
}
